import {
  buttonsLabels,
  subRoles,
  subRolesCheckbox,
} from "../../../utils/constants";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { HiOutlineMail } from "react-icons/hi";
import { useTranslation } from "react-i18next";

export const InstitutionsUserForms = ({ user, isFirst }) => {
  const { user: userId } = useParams();
  const { t } = useTranslation(); // Initialize useTranslation

  const [subRoleitemDisabled, setSubRoleitemDisabled] = useState([]);

  const {
    info: { firstname, lastname, genre, phone, title },
    status,
    email,
  } = user;

  useEffect(() => {
    if (
      user.subRoles.length > 0 &&
      user.subRoles.includes(subRoles.institutionAdmin)
    ) {
      setSubRoleitemDisabled([
        subRoles.institutionDemander,
        subRoles.institutionFinance,
      ]);
    }
  }, [user.subRoles]);

  return [
    {
      parentLabel: "",
      children: [
        {
          label: t("institutionsUserForms.lastname"),
          name: "info.lastname",
          value: lastname,
          type: "input",
          required: true,
          col: 24,
        },
        {
          label: t("institutionsUserForms.firstname"),
          name: "info.firstname",
          value: firstname,
          required: true,
          type: "input",
          col: 24,
        },
        {
          label: t("institutionsUserForms.title"),
          name: "info.title",
          watchValues: [
            subRoles.institutionDemander,
            subRoles.institutionAdmin,
            subRoles.institutionFinance,
          ],
          watchRequiredCondition: true,
          watch: "subRoles",
          value: title,
          type: "input",
          required: true,
          col: 24,
        },
        {
          label: t("institutionsUserForms.email"),
          required: true,
          name: "email",
          normalize: value => value && value.toLowerCase(),
          addonBefore: <HiOutlineMail />,
          value: email,
          type: "email",
          col: 24,
        },
        {
          label: t("institutionsUserForms.phone"),
          name: "info.phone",
          addonBefore: "+41",
          value: phone,
          type: "input",
          col: 24,
        },
        userId !== "new"
          ? {
              label: t("institutionsUserForms.access"),
              name: "status",
              value: status,
              required: true,
              type: "select",
              selectContent: [
                {
                  label: t("institutionsUserForms.accessYes"),
                  value: "active",
                },
                {
                  label: t("institutionsUserForms.accessNo"),
                  value: "inactive",
                },
              ],
              col: 24,
            }
          : null,
      ],
    },
    {
      parentLabel: t("institutionsUserForms.roles"),
      children: [
        {
          label: "",
          name: "subRoles",
          value: user.subRoles,
          type: "checkbox",
          required: true,
          onChange: props => {
            const { ref, value } = props;
            if (ref !== undefined) {
              if (value.includes(subRoles.institutionAdmin)) {
                ref.current.setFieldsValue({
                  subRoles: [
                    subRoles.institutionAdmin,
                    subRoles.institutionDemander,
                    subRoles.institutionFinance,
                  ],
                });

                setSubRoleitemDisabled([
                  subRoles.institutionDemander,
                  subRoles.institutionFinance,
                ]);
              } else {
                setSubRoleitemDisabled([]);
              }
            }
          },
          itemDisabled: subRoleitemDisabled,
          checkboxs: subRolesCheckbox(),
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label:
            userId === "new"
              ? t("institutionsUserForms.createUser")
              : t("institutionsUserForms.save"),
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
};
